<section class="reference">
  <h1>Enter your reference ID</h1>

  <input
    type="text"
    class="reference-input mb-2"
    placeholder="XXXX-XXX-XXXXXX"
    name="referenceKey"
    [(ngModel)]="referenceKey"
    #referenceKeyModel="ngModel"
    required
  />

  @if (submitted && referenceKeyModel.invalid) {
    <p class="error text-danger text__small">Reference ID is required</p>
  }

  <button
    class="btn__primary w-100 no-margin-l no-margin-r btn__md btn"
    (click)="submit()"
  >
    Submit
  </button>
</section>
